import React from "react";
import { Container } from "react-bootstrap";
import "./rewardmanagement.css";

const LoyaltyManagement = () => {
  return (
    <Container className="py-5 reward-management">
      <h2 className="section-title">Loyalty Management System</h2>
      <p className="lead">
        Cloud 10 provides an insight-powered loyalty system crafted for
        hospitality leaders who want to deepen guest relationships and drive
        long-term engagement. It combines real-time data with thoughtful design
        to deliver loyalty programs that feel personal, rewarding, and always
        one step ahead.
      </p>

      <h4 className="subheading">🧰 Core Features:</h4>
      <ul className="feature-list">
        <li>
          <strong>Dynamic Tiering System:</strong> Create motivating progression
          paths with customizable tiers, rewarding guests with privileges like
          VIP amenities, early access, or premium upgrades.
        </li>
        <li>
          <strong>Flexible Rewards Engine:</strong> Design your own rules for
          how and when rewards are earned, and let guests redeem points
          instantly for services, experiences, or curated partner perks.
        </li>
        <li>
          <strong>Behavior-Based Personalization:</strong> Automatically tailor
          guest recognition and offers based on stay history, preferences, and
          milestone moments—like a surprise welcome amenity or an exclusive
          retreat offer.
        </li>
        <li>
          <strong>Cross-Channel Experience Integration:</strong> Ensure that
          every guest interaction—from mobile to on-property—is synced,
          consistent, and reflects their loyalty status and preferences.
        </li>
        <li>
          <strong>Live Engagement Dashboard:</strong> Empower your team with
          visual insights into reward redemptions, guest activity trends, and
          campaign performance—all in real time.
        </li>
      </ul>

      <h4 className="subheading mt-5">📈 Value That Speaks Volumes:</h4>
      <ul className="feature-list">
        <li>
          <strong>Boost repeat bookings</strong> with meaningful rewards that
          reflect real guest behaviours.
        </li>
        <li>
          <strong>Elevate satisfaction</strong> by making loyalty a natural,
          seamless part of the guest journey.
        </li>
        <li>
          <strong>Drive brand advocacy</strong> by recognizing what makes each
          guest feel valued.
        </li>
      </ul>
    </Container>
  );
};

export default LoyaltyManagement;
